import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { resolveFunnelUrlByMonetizationTest } from '@/helpers';
import { landingEnhancerConfig } from '@/data/landingConfig/landingEnhancerConfig';
import { MONETIZATION_TEST } from '@/constants';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_Enhancer } from './schemaObject';

interface Props {}
const ImageEnhancer: React.FC<Props> = () => {
	const funnelUrl = resolveFunnelUrlByMonetizationTest(
		{
			[MONETIZATION_TEST.NON_TIER_1]:
				GenerateLandingLinkService.funnelImageEnhancementV3,
		},
		GenerateLandingLinkService.funnelImageEnhancement,
	);

	return (
		<>
			<AggregateSchema schema={schemaObject_Enhancer} />
			<LandingTemplate
				data={landingEnhancerConfig}
				funnelLinkService={funnelUrl}
			/>
		</>
	);
};

export default ImageEnhancer;
